import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    categoryList: [],
    toBeTrainMessages: {},
    trainedMessages: [],
  },
  getters: {
    categoryList: (state) => state.categoryList,
    toBeTrainMessages: (state) => state.toBeTrainMessages,
    trainedMessages: (state) => state.trainedMessages,
  },
  actions: {
    loadCategoryList(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice.loadCategoryList(modelId).then((response) => {
          context.commit('setCategoryListData', response.data.data);
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    loadTrainedMessageList(context, params) {
      const { modelId, categoryId } = params;
      return new Promise((resolve, reject) => {
        alice.loadTrainedMessageList(modelId, categoryId).then((response) => {
          context.commit('setTrainedMessageListData', response.data.data);
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    resetTrainedMessageList(context) {
      context.commit('setTrainedMessageListData', []);
    },
    trainModel(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice.trainModel(modelId).then((response) => {
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    createQuestion(context, params) {
      const { modelId, categoryId, message } = params;
      return new Promise((resolve, reject) => {
        alice.createQuestion(modelId, categoryId, message).then((response) => {
          context.dispatch('loadTrainedMessageList', params);
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    updateQuestion(context, params) {
      const {
        modelId, categoryId, questionId, message,
      } = params;
      return new Promise((resolve, reject) => {
        alice.updateQuestion(modelId, categoryId, questionId, message).then((response) => {
          context.dispatch('loadTrainedMessageList', params);
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    deleteQuestion(context, params) {
      const { modelId, categoryId, questionId } = params;
      return new Promise((resolve, reject) => {
        alice.deleteQuestion(modelId, categoryId, questionId).then((response) => {
          context.dispatch('loadTrainedMessageList', params);
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    addToBeTrainedList(context, params) {
      context.commit('addToBeTrainedList', params);
    },
  },
  mutations: {
    setCategoryListData(state, data) {
      Vue.set(state, 'categoryList', data);
    },
    setTrainedMessageListData(state, data) {
      Vue.set(state, 'trainedMessages', data);
    },
    addToBeTrainedList(state, data) {
      const newState = state;
      const { message, modelId } = data;
      if (typeof state.toBeTrainMessages[modelId] === 'undefined') {
        Vue.set(newState.toBeTrainMessages, modelId, []);
      }
      if (newState.toBeTrainMessages[modelId].indexOf(message) < 0) {
        newState.toBeTrainMessages[modelId].push(message);
      }
    },
  },
};
